import { Injectable } from '@angular/core';

import {
	COLUMN_MODEL_ID,
	FILTER_MODEL_ID,
	PROFILE_ID,
} from '../../core/constants';
import { ColumnModelItemEntity } from '../domain/column-model-item.entity';
import { FilterModelItemEntity } from '../domain/filter-model-item.entity';
import { ProfileItemEntity } from '../domain/profile-item.entity';

@Injectable()
export class HighlightProvider {
	public constructor() {}

	public setRelatedElementsHighlight(
		hoverElementType: 'COLUMN_MODEL' | 'FILTER_MODEL' | 'PROFILE',
		hoveElement:
			| ColumnModelItemEntity
			| FilterModelItemEntity
			| ProfileItemEntity,
		enabled: boolean
	): void {
		if (hoverElementType === 'PROFILE') {
			const element = hoveElement as ProfileItemEntity;

			if (element.columnModelId === '') {
				return;
			}
			const columnModelElements = document.querySelectorAll<HTMLElement>(
				`[data-${COLUMN_MODEL_ID}="${element.columnModelId}"]`
			);

			columnModelElements.forEach((element) => {
				element.classList.toggle('highlight-row', enabled);
			});

			if (element.filterModelIds.size === 0) {
				return;
			}
			const selector = element.filterModelIds
				.toArray()
				.map((filterId) => `[data-${FILTER_MODEL_ID}="${filterId}"]`)
				.join(',');

			const filterModelElements =
				document.querySelectorAll<HTMLElement>(selector);

			filterModelElements.forEach((element) => {
				element.classList.toggle('highlight-row', enabled);
			});
			return;
		}

		if (hoverElementType === 'FILTER_MODEL') {
			const element = hoveElement as FilterModelItemEntity;

			if (element.linkedProfileIds.size === 0) {
				return;
			}
			const selector = element.linkedProfileIds
				.toArray()
				.map((profileId) => `[data-${PROFILE_ID}="${profileId}"]`)
				.join(',');

			const profilesElements = document.querySelectorAll<HTMLElement>(selector);

			profilesElements.forEach((element) => {
				element.classList.toggle('highlight-row', enabled);
			});
			return;
		}

		if (hoverElementType === 'COLUMN_MODEL') {
			const element = hoveElement as ColumnModelItemEntity;

			if (element.linkedProfileIds.size === 0) {
				return;
			}

			const selector = element.linkedProfileIds
				.toArray()
				.map((profileId) => `[data-${PROFILE_ID}="${profileId}"]`)
				.join(',');

			const profilesElements = document.querySelectorAll<HTMLElement>(selector);

			profilesElements.forEach((element) => {
				element.classList.toggle('highlight-row', enabled);
			});
			return;
		}
	}
}
